import { useEffect, useState } from 'react';
import { api, getApiUrl } from '../../utils/apiConfig';

export async function workspaceRequest(scope, path, { method = 'GET', body, signal } = {}) {
  try {
    const response = await api({ url: getApiUrl(`/api/v2/optimization-workspace${path}`), method, signal,
      ...(method === 'GET' ? { params: scope } : { data: { ...body, ...scope } }) });
    return response.data;
  } catch (error) {
    if (error.code === 'ERR_CANCELED') throw error;
    const failure = new Error(error.response?.data?.error || 'The workspace request could not be completed. Please try again.');
    failure.code = error.response?.data?.code;
    failure.status = error.response?.status;
    throw failure;
  }
}

/** Never render data from a previous account, filter, or date window while the
 * next request is loading. Abort also prevents late requests overwriting it. */
export function useWorkspaceResource(scope, path, { method = 'GET', body = null, refresh = 0, enabled = true } = {}) {
  const key = JSON.stringify({ scope, path, method, body, enabled });
  const [state, setState] = useState({ key: null, data: null, error: null, loading: true });
  useEffect(() => {
    if (!enabled || !scope.accountId || !scope.userId) return undefined;
    const controller = new AbortController();
    setState(previous => ({ key, data: previous.key === key ? previous.data : null, error: null, loading: true }));
    workspaceRequest(scope, path, { method, body, signal: controller.signal }).then(data => {
      if (!controller.signal.aborted) setState({ key, data, error: null, loading: false });
    }).catch(error => {
      if (!controller.signal.aborted) setState({ key, data: null, error, loading: false });
    });
    return () => controller.abort();
    // key contains the complete scope and request, without object-identity churn.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, refresh]);
  return state.key === key ? state : { data: null, error: null, loading: enabled };
}
